import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 1000,
    padding: theme.spacing(8, 8),
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 4px 54px rgba(0, 0, 0, 0.25)',
  },
}));
